import React from 'react';
import { Button } from 'react-bootstrap';

export default function ErrorPage({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) {
    function goBack() {
        resetErrorBoundary();
    }
    return (
        <div className="p-5">
            <h1 className="mb-3">Erreur!</h1>
            <h5 className="mb-2">Une erreur est survenue en chargeant cette page.</h5>
            <Button onClick={goBack}>Retour à la page précédente</Button>
        </div>
    );
}
